import React, { Component } from "react";
import { connect } from "react-redux";
import { change, Field, reduxForm } from "redux-form";
import { Button, Col, Row } from "react-bootstrap";
import PsLabel from "./inputs/PsLabel";
import {
  getAnzahlDimensionen,
  getRetourenExist,
  inputsFormName
} from "../selectors/inputsSelectors";
import DimensionSelect from "./inputs/DimensionSelect";
import PsInput from "./inputs/PsInput";
import bestellungenEinheiten from "../db/bestellungenEinheiten.json";
import warenlieferungEinheit from "../db/warenlieferungEinheit.json";
import warenlieferungZeiteinheit from "../db/warenlieferungZeiteinheit.json";
import versandCarrier from "../db/versandCarrier.json";
import PsCheckbox from "./inputs/PsCheckbox";
import PsLoadingSpinner from "./inputs/PsLoadingSpinner";
import { number, required } from "../validation";
import RowInput from "./inputs/RowInput";

class Start extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false
    };
  }

  render() {
    return (
      <div className="container">
        <PsLoadingSpinner isLoading={this.state.loading} />

        <Row>
          <Col xs={12}>
            <form
              onSubmit={this.props.handleSubmit(formValues => {
                this.setState({ loading: true });

                fetch(process.env.REACT_APP_BACKEND_URL + "/prod/calculate", {
                  method: "POST",
                  headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json"
                  },
                  body: JSON.stringify(this.props.reduxstate)
                })
                  .then(response => {
                    this.setState({ loading: false });
                    if (response.ok) {
                      return response.json().then(result => {
                        this.props.dispatch(
                          change(inputsFormName, "ergebnisValues", result)
                        );
                        this.props.history.push("ergebnis");
                      });
                    }
                    console.error(response);
                  })
                  .catch(error => {
                    this.setState({ loading: false });
                    console.error(error);
                  });
              })}
              style={{ paddingTop: "40px" }}
            >
              <h2>Angaben zur Ihren Artikeln</h2>

              <Row>
                <Col md={12}>
                  <Field
                    name="anzahlDimensionen"
                    label={
                      "Bitte geben Sie an, wieviel unterschiedlich große Artikelgruppen Sie anbieten"
                    }
                    className="form-control"
                    component={({
                      input: { onChange, name, value },
                      label,
                      meta,
                      className
                    }) => (
                      <PsLabel label={label} meta={meta}>
                        <select
                          name={name}
                          onChange={onChange}
                          value={value}
                          className={className}
                        >
                          {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map(key => (
                            <option value={key} key={key}>
                              {key}
                            </option>
                          ))}
                        </select>
                      </PsLabel>
                    )}
                  />
                  <table className="table table-striped">
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>Breite</th>
                        <th>Höhe</th>
                        <th>Tiefe</th>
                        <th>Stückmenge</th>
                      </tr>
                    </thead>
                    <tbody>
                      {Array.from(
                        Array(parseInt(this.props.anzahlDimensionen, 10)).keys()
                      ).map((v, index) => {
                        return (
                          <tr key={index}>
                            <td>{index + 1}</td>
                            <td>
                              <DimensionSelect index={index} name={"breite"} />
                            </td>
                            <td>
                              <DimensionSelect index={index} name={"hoehe"} />
                            </td>
                            <td>
                              <DimensionSelect index={index} name={"tiefe"} />
                            </td>
                            <td>
                              <Field
                                name={`${index}.mengenstueck`}
                                validate={[required, number]}
                                placeholder="Anzahl Artikel"
                                component={RowInput}
                              />
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </Col>

                <Col md={6}>
                  <Field
                    name="anzahlWarenlieferung"
                    label={
                      "Wieviele Waren werden regelmäßig ins Lager angeliefert?"
                    }
                    validate={[required, number]}
                    className="form-control"
                    placeholder="Anzahl Warenlieferungen pro Tag/Woche/Monat"
                    component={PsInput}
                  />
                </Col>
                <Col md={3}>
                  <Field
                    name="warenlieferungEinheit"
                    label={"Bitte Einheit angeben"}
                    className="form-control"
                    component={({
                      input: { onChange, name, value },
                      label,
                      meta,
                      className
                    }) => (
                      <PsLabel label={label} meta={meta}>
                        <select
                          name={name}
                          onChange={onChange}
                          value={value}
                          className={className}
                        >
                          {warenlieferungEinheit.map(einheit => (
                            <option value={einheit.value} key={einheit.value}>
                              {einheit.label}
                            </option>
                          ))}
                        </select>
                      </PsLabel>
                    )}
                  />
                </Col>
                <Col md={3}>
                  <Field
                    name="warenlieferungZeiteinheit"
                    label={"Bitte Zeitraum angeben"}
                    className="form-control"
                    component={({
                      input: { onChange, name, value },
                      label,
                      meta,
                      className
                    }) => (
                      <PsLabel label={label} meta={meta}>
                        <select
                          name={name}
                          onChange={onChange}
                          value={value}
                          className={className}
                        >
                          {warenlieferungZeiteinheit.map(einheit => (
                            <option value={einheit.value} key={einheit.value}>
                              {einheit.label}
                            </option>
                          ))}
                        </select>
                      </PsLabel>
                    )}
                  />
                </Col>
              </Row>

              <h2>Angaben zur Ihren Bestellungen</h2>

              <Row>
                <Col md={9}>
                  <Field
                    name="anzahlBestellungen"
                    label={"Wieviele Bestellungen werden getätigt?"}
                    className="form-control"
                    validate={[required, number]}
                    placeholder="Anzahl Bestellungen pro Tag/Woche/Monat"
                    component={PsInput}
                  />
                </Col>
                <Col md={3}>
                  <Field
                    name="bestellungenEinheit"
                    label={"Bitte Zeitraum angeben"}
                    className="form-control"
                    component={({
                      input: { onChange, name, value },
                      label,
                      meta,
                      className
                    }) => (
                      <PsLabel label={label} meta={meta}>
                        <select
                          name={name}
                          onChange={onChange}
                          value={value}
                          className={className}
                        >
                          {bestellungenEinheiten.map(einheit => (
                            <option value={einheit.value} key={einheit.value}>
                              {einheit.label}
                            </option>
                          ))}
                        </select>
                      </PsLabel>
                    )}
                  />
                </Col>
                <Col md={12}>
                  <Field
                    name="durchschnittArtikelProBestellung"
                    label={
                      "Wieviele Artikel befinden sich im Durchschnitt in einer Bestellung?"
                    }
                    validate={[required, number]}
                    className="form-control"
                    placeholder="Durchschnittliche Anzahl an Artikeln"
                    component={PsInput}
                  />
                </Col>
              </Row>

              <h2>Versand</h2>

              <Field
                name="versandCarrier"
                label={"Bevorzugter Versandanbieter?"}
                className="form-control"
                component={({
                  input: { onChange, name, value },
                  label,
                  meta,
                  className
                }) => (
                  <PsLabel label={label} meta={meta}>
                    <select
                      name={name}
                      onChange={onChange}
                      value={value}
                      className={className}
                    >
                      {versandCarrier.map(carrier => (
                        <option value={carrier.value} key={carrier.value}>
                          {carrier.label}
                        </option>
                      ))}
                    </select>
                  </PsLabel>
                )}
              />

              <h2>Retouren</h2>

              <Field
                name="retourenExist"
                label={"Gibt es Retouren?"}
                className="form-control"
                component={PsCheckbox}
              />

              {this.props.retourenExist && (
                <Row>
                  <Col md={9}>
                    <Field
                      name="anzahlRetouren"
                      label={"Wieviele Retouren werden getätigt?"}
                      className="form-control"
                      placeholder="Anzahl Retouren"
                      validate={[required, number]}
                      component={PsInput}
                    />
                  </Col>
                  <Col md={3}>
                    <Field
                      name="retourenEinheit"
                      label={"Einheit"}
                      className="form-control"
                      component={({
                        input: { onChange, name, value },
                        label,
                        meta,
                        className
                      }) => (
                        <PsLabel label={label} meta={meta}>
                          <select
                            name={name}
                            onChange={onChange}
                            value={value}
                            className={className}
                          >
                            {bestellungenEinheiten.map(einheit => (
                              <option value={einheit.value} key={einheit.value}>
                                {einheit.label}
                              </option>
                            ))}
                          </select>
                        </PsLabel>
                      )}
                    />
                  </Col>
                  <Col md={6}>
                    <Field
                      name="durchschnittArtikelProRetoure"
                      label={
                        "Durchschnittliche Anzahl an Artikeln pro Retoure?"
                      }
                      className="form-control"
                      placeholder="Durchschnittliche Anzahl an Retouren"
                      validate={[required, number]}
                      component={PsInput}
                    />
                  </Col>
                  <Col md={6}>
                    <Field
                      name="anteilBWare"
                      label={
                        "Wieviele retournierte Artikel sind B-Ware? (=Überarbeitung notwendig)"
                      }
                      className="form-control"
                      placeholder="X% der retournierten Artikel sind B-Ware"
                      validate={[required, number]}
                      component={PsInput}
                    />
                  </Col>
                </Row>
              )}

              <Button
                disabled={this.props.pristine || this.props.invalid}
                bsStyle="primary"
                type="submit"
                style={{ margin: "30px 0" }}
              >
                Angebot berechnen
              </Button>
            </form>
          </Col>
        </Row>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    anzahlDimensionen: getAnzahlDimensionen(state),
    retourenExist: getRetourenExist(state),
    reduxstate: state
  };
};

const Connected = connect(mapStateToProps)(Start);

export default reduxForm({
  form: inputsFormName,
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: false,
  initialValues: {
    anzahlDimensionen: 1,
    retourenEinheit: "tag",
    bestellungenEinheit: "tag",
    versandCarrier: "dhl",
    warenlieferungZeiteinheit: "tag",
    warenlieferungEinheit: "karton",
    0: {
      breite: 10,
      hoehe: 10,
      tiefe: 10,
      mengenstueck: null
    }
  }
})(Connected);



// WEBPACK FOOTER //
// ./src/components/Start.js